// Down chevron matching Figma "Icon / Basic / Navigation Chevron". Used by the
// CRM classic complete-features-list toggle; rotates to point up when expanded.
import { jsx as _jsx } from "react/jsx-runtime";
const ChevronSvg = ({ className })=>/*#__PURE__*/ _jsx("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5 7.5L10 12.5L15 7.5",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
export default ChevronSvg;
